<div class="po-mb-2">
  <po-button-group [p-buttons]="modeButtons" p-toggle="single"></po-button-group>
</div>

<p *ngIf="hasData" class="po-font-text-small po-mb-2">
  {{ contextLabel }}
  <span class="po-icon po-icon-info" [p-tooltip]="columnHelp"
    p-tooltip-position="bottom" p-append-in-body="true"></span>
</p>

<!-- Fonte (busca livre por caminho, que já inclui o nome do arquivo) sozinho numa linha
     cheia: po-search não tem label nativo como po-multiselect, e forçar os dois lado a
     lado nunca bateu certinho (três tentativas, três alinhamentos diferentes quebrados).
     Categoria e Linguagem ficam juntos embaixo — mesmo componente, alinham sozinhos. -->
<div class="po-row po-mb-2">
  <po-search
    class="po-sm-12"
    p-aria-label="Pesquisar no ranking de fontes"
    p-search-type="trigger"
    [p-literals]="searchLiterals"
    (p-change-model)="searchRanking($event)">
  </po-search>
</div>

<div class="po-row po-mb-2">
  <po-multiselect
    name="hotspotCategory"
    class="po-sm-12 po-md-6"
    p-label="Categoria"
    p-placeholder="Todas as categorias"
    p-filter-mode="contains"
    [p-options]="categoryOptions"
    [ngModel]="selectedCategories"
    (ngModelChange)="categoriesChanged($event)">
  </po-multiselect>

  <po-multiselect
    name="hotspotLanguage"
    class="po-sm-12 po-md-6"
    p-label="Linguagem"
    p-placeholder="Todas as linguagens"
    p-filter-mode="contains"
    [p-options]="languageOptions"
    [ngModel]="selectedLanguages"
    (ngModelChange)="languagesChanged($event)">
  </po-multiselect>
</div>

<po-table
  *ngIf="hasData || loading; else emptyHotspots"
  class="source-quality-table"
  [p-columns]="columns"
  [p-items]="rows"
  [p-actions]="actions"
  p-actions-right="true"
  [p-height]="height"
  [p-hide-table-search]="true"
  [p-hide-columns-manager]="true"
  [p-loading]="loading"
  [p-show-more-disabled]="allRowsVisible"
  (p-show-more)="showMore()">

  <ng-template p-table-column-template [p-property]="'sourceCell'" let-value>
    <div class="source-quality-table__cell source-quality-table__source" [title]="value.path">
      <span class="po-font-text-bold">{{ value.name }}</span>
      <span class="po-font-text-small source-quality-table__detail">{{ value.detail }}</span>
    </div>
  </ng-template>

  <ng-template p-table-column-template [p-property]="'countCell'" let-value>
    <div class="source-quality-table__cell" [title]="value.title || ''">
      <div class="source-quality-table__tags"
        [class.source-quality-table__tags--wrap]="mode === 'category' && selectedCategories.length > 0">
        <po-tag *ngFor="let tag of value.tags" [p-value]="tag.label" [p-type]="tag.type" p-inverse="true"></po-tag>
      </div>
      <div class="source-quality-table__bar" *ngIf="value.segments.length" role="img"
        [attr.aria-label]="'Proporção por severidade'">
        <span *ngFor="let segment of value.segments"
          [ngClass]="'source-quality-table__segment--' + segment.severity"
          [style.width.%]="segment.percent" [title]="segment.title"></span>
      </div>
    </div>
  </ng-template>
</po-table>

<ng-template #emptyHotspots>
  <p class="po-font-text-small" *ngIf="!loading && !loadError">Nenhum fonte com apontamentos nesta visão.</p>
  <p class="po-font-text-small" *ngIf="loadError">Não foi possível carregar o ranking.</p>
</ng-template>
